
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604125589521",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2075",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M938.666667 0h-853.333334C38.229333 0 0 38.229333 0 85.333333v853.333334c0 47.104 38.229333 85.333333 85.333333 85.333333h853.333334c47.104 0 85.333333-38.229333 85.333333-85.333333v-853.333334C1024 38.229333 985.770667 0 938.666667 0m-152.234667 530.432c-19.114667 133.802667-134.485333 237.568-274.432 237.568-139.264 0-254.634667-103.765333-274.432-237.568-26.624-8.192-45.738667-32.085333-45.738667-60.757333 0-35.498667 28.672-64.170667 64.170667-64.170667s64.170667 28.672 64.170667 64.170667c0 26.624-16.384 49.152-39.594667 59.392 18.432 111.274667 114.688 196.608 231.424 196.608s212.992-85.333333 231.424-196.608a63.6928 63.6928 0 0 1-39.594667-59.392c0-35.498667 28.672-64.170667 64.170667-64.170667s64.170667 28.672 64.170667 64.170667c0 28.672-19.797333 52.565333-45.738667 60.757333m173.397333-380.928c0 23.210667-19.114667 43.008-43.008 43.008H106.496c-23.210667 0-43.008-19.114667-43.008-43.008v-43.008c0-23.210667 19.114667-43.008 43.008-43.008h811.008c23.210667 0 43.008 19.114667 43.008 43.008v43.008z",
        "p-id": "2076"
      }
    }
  ]
})
    }
  